import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { StorageService, UsuariosService } from '../../servicios/index.service';
import { FormGroup, FormControl,Validators } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

  form:FormGroup;
  user_msj:boolean;
  error_msj:boolean;

  constructor( public router:Router, private storage:StorageService, private _us:UsuariosService ) {
    this.navegador();
    this.form = new FormGroup({
      'usuario':new FormControl('', Validators.required),
      'password':new FormControl('', Validators.required)
    });
  }

  ngOnInit() {
    document.getElementById('body').className = 'hold-transition login-page fondo';
  }

  verifica(){
    let data_form = this.form.value;
    if( data_form.usuario.length != 0 && data_form.password.length != 0){
        this._us.valida_datos(data_form.usuario).subscribe(data=>{
            if( data.pass == data_form.password && data.rol !== 3 || data.rol == "account-man" || data.rol == "account-adm" ){
              this.storage.guarda_st("user", data_form.usuario);
              this.storage.guarda_st("rol", data.rol);
              this.router.navigate(["home"]);
              this.user_msj = false;
            }else{
              this.error_msj = true;
            }
        });
    }else{
      this.user_msj = true;
    }
  }

  navegador(){
    let user = this.storage.user_consult();
    if( user ){
      return this.router.navigate(['home']);
    }
  }


}



// WEBPACK FOOTER //
// C:/xampp/htdocs/service_tracking/web/service_tracking/src/app/components/login/login.component.ts